import Swiper from 'swiper';
import { assign } from 'lodash';

export interface IVouchersCarousel {
    containerClass: string;
    slidesPerView?: number | string;
    breakpoints?: any;
    slidesPerGroup?: any;
    autoplay?: any;
    spaceBetween?: number;
    navigation?: any;
    autoHeight?: boolean;
    loop?: boolean;
    loopFillGroupWithBlank?: boolean,
    autoplayVideo?: boolean;
    pageNumberPreposition?: string;
    pagination?: any;
    watchOverflow?: boolean;
    freeMode?: boolean;
}

export class VouchersCarousel {
    //these params are exposed to the file you intialize your gallery in, so you can initialize multiple
    //gallery versions across your project or just be able to configure without diving into this file
    params: IVouchersCarousel = {
        containerClass: 'adage-gallery-js',
        slidesPerView: 1,
        breakpoints: {
            640: {
                spaceBetween: 16
            }
        },
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoHeight: false,
        autoplayVideo: false,
        pageNumberPreposition: ' of ',
        watchOverflow: false,
        freeMode: false,
    };
    gallery: any;
    activeSlide: any;
    previousSlide: any;
    activeIndex: any;
    previousIndex: number; // swiper's previousIndex implementation doesn't work with loop: true so we need to do it manually
    galleryId: string;

    constructor(params?: IVouchersCarousel) {
        assign(this.params, params);

        this.gallery = new Swiper(`.${this.params.containerClass}`, {
            // feel free to add any other Swiper settings if needed
            slidesPerView: this.params.slidesPerView,
            slidesPerGroup: this.params.slidesPerGroup,
            autoplay: this.params.autoplay,
            breakpoints: this.params.breakpoints,
            spaceBetween: this.params.spaceBetween,
            navigation: this.params.navigation,
            autoHeight: this.params.autoHeight,
            loop: false,
            on: {
                slideChangeTransitionStart: this.handleSlide.bind(this)
            },
            a11y: true,
            pagination: {
                el: '.swiper-pagination',
            },
            watchOverflow: this.params.watchOverflow,
            freeMode: this.params.freeMode,
        });


        this.galleryId = this.gallery.el.getAttribute('data-unique-id');
        this.initCallback();
    }

    initCallback() {
        this.activeSlide = this.gallery.slides[this.gallery.activeIndex];
        this.activeIndex = this.gallery.activeIndex;
    }

    handleSlide() {
        if (this.gallery) {
            this.previousSlide = this.activeSlide;
            this.previousIndex = this.activeIndex;
            this.activeSlide = this.gallery.slides[this.gallery.activeIndex];
            this.activeIndex = this.gallery.activeIndex;
            this.disableSlide(this.previousSlide);
            this.enableSlide(this.activeSlide);
        }
    }

    disableSlide(slide) {
        // disable tabbing on tabbable content by default to stop trapping keyboard, and hide from screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = -1;
        });
        slide.setAttribute('aria-hidden', 'true');
    }

    enableSlide(slide) {
        // enable tabbing on active slide and show to screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = 0;
        });
        slide.setAttribute('aria-hidden', 'false');
    }
}